import { IUseForm } from '../../../common/interface/form';
import { FormError } from '../form-error';

import Grid from '../../UI/atoms/Grid';
import TextField from '../../UI/atoms/TextField';
import Text from '../../UI/atoms/Text';
import Button from '../../UI/atoms/Button';
const regexPassword = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=\-,\\.<>/\\?~\\(\\)\\_\\[\]\\{\\}\\|;:])(?=.*[0-9]).{8,}$/; // 비밀번호 체크 정규식 (영문+숫자+특문조합 8자 이상)

interface IProps {
  useForm: IUseForm;
  onSubmit: (data: any) => Promise<any>;
  inputPassword: string;
}

function Presenter({ useForm, inputPassword, onSubmit }: IProps) {
  return (
    <form onSubmit={useForm.handleSubmit(onSubmit)}>
      <Grid display="flex" direction="column" alignItems="center" justifyContent="center" height={400} left={30} right={30}>
        <Text fontSize="1.3rem" fontWeight={500}>
          새로운 비밀번호 입력
        </Text>
        <Grid top={60} bottom={30}>
          <TextField
            type="password"
            placeholder="영문 + 숫자 + 특문조합 8자 이상"
            {...useForm.register(`password`, { required: true, minLength: 8, pattern: regexPassword })}
          />
          {useForm?.errors?.password && useForm.errors.password.type === 'required' && <FormError errorMessage={'비밀번호는 필수 입력 항목입니다.'} />}
          {useForm?.errors?.password && useForm.errors.password.type === 'minLength' && <FormError errorMessage={'비밀번호는 8자 이상 입력해 주세요.'} />}
          {useForm?.errors?.password && useForm.errors.password.type === 'pattern' && (
            <FormError errorMessage={'비밀번호는 영문+숫자+특문 8자 이상 입력해 주세요.'} />
          )}
        </Grid>
        <Grid bottom={60}>
          <TextField
            type="password"
            placeholder="비밀번호를 한번 더 입력해 주세요"
            {...useForm.register(`confirmPassword`, { required: true, minLength: 8, pattern: regexPassword, validate: (value) => value === inputPassword })}
          />
          {useForm?.errors?.confirmPassword && useForm.errors.confirmPassword.type === 'required' && (
            <FormError errorMessage={'비밀번호체크는 필수 입력 항목입니다.'} />
          )}
          {useForm?.errors?.confirmPassword && useForm.errors.confirmPassword.type === 'minLength' && (
            <FormError errorMessage={'비밀번호는 8자 이상 입력해 주세요.'} />
          )}
          {useForm?.errors?.confirmPassword && useForm.errors.confirmPassword.type === 'pattern' && (
            <FormError errorMessage={'비밀번호는 영문+숫자+특문 8자 이상 입력해 주세요.'} />
          )}
          {useForm.errors?.confirmPassword && useForm.errors.confirmPassword.type === 'validate' && (
            <FormError errorMessage={'비밀번호와 일치하지 않습니다.'} />
          )}
        </Grid>
        <Button type="submit" color="main">
          비밀번호 변경
        </Button>
      </Grid>
    </form>
  );
}

export default Presenter;
